/**
 *
 * @param file
 * @returns {Promise<unknown>}
 */
export function loadFileAsText(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.onload = event => resolve(event.target.result);
    fileReader.onerror = error => reject(error);
    fileReader.readAsText(file, 'UTF-8');
  });
}

export function getFilesWithDeclutterGroupData({files, interval}) {
  const dayjs = useDayjs();
  let currentGroup = {};
  let lastGroupFile = null;

  const isFileInCurrentGroup = file => {
    const lastGroupFileDate = dayjs(lastGroupFile.taken_at);
    const checkFileDate = dayjs(file.taken_at);

    return lastGroupFileDate.diff(checkFileDate, 'second', true) <= interval;
  }

  return files
    ?.map(file => {
      if (!lastGroupFile || !isFileInCurrentGroup(file)) {
        currentGroup = {
          id: `group-of-file-${file.id}`,
          get name() {
            return `${this.fileCount} Similar`;
          },
          fileCount: 0
        };
      }

      lastGroupFile = file;
      currentGroup.fileCount++;

      return Object.assign({}, file, {group: currentGroup});
    })
    .filter(file => file.group.fileCount > 1);
}

export function captureFrameFromVideo({videoElement, maxDimension = Infinity}) {

  // Create an offscreen canvas
  const canvas = document.createElement('canvas');
  canvas.style.position = 'absolute';
  canvas.style.left = '-9999px';
  canvas.style.top = '0';
  document.body.appendChild(canvas);

  const context = canvas.getContext('2d');

  // Set canvas size to video size
  if (videoElement.videoWidth <= maxDimension && videoElement.videoHeight <= maxDimension) {
    canvas.width = videoElement.videoWidth;
    canvas.height = videoElement.videoHeight;
  } else {
    if (videoElement.videoWidth > videoElement.videoHeight) {
      const scale = maxDimension / videoElement.videoWidth;

      canvas.width = maxDimension;
      canvas.height = Math.round(videoElement.videoHeight * scale);
    } else {
      const scale = maxDimension / videoElement.videoHeight;
      canvas.width = Math.round(videoElement.videoWidth * scale);
      canvas.height = maxDimension;
    }
  }

  // Draw the current frame from the video to the canvas
  context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);

  // Convert canvas content to a data URL (base64-encoded image)
  const imgData = canvas.toDataURL('image/jpeg', 0.85);

  //cleanup
  canvas.remove();

  return imgData;
}
